module.exports = __webpack_public_path__ + "banquet/components/images/trashcan.c1912156a634f486138130daf7b27f41.png";


//////////////////
// WEBPACK FOOTER
// ./banquet/components/images/trashcan.png
// module id = 1045
// module chunks = 1